const prefix = 'drivex/session';

const LOG_IN = `${prefix}/LOG_IN`;
const LOG_OUT = `${prefix}/LOG_OUT`;

export default {
  LOG_IN,
  LOG_OUT,
};
